import React from 'react';
import asyncComponent from '../../../util/asyncComponent';

import PrivateRoute from './PrivateRoute';
import { Switch } from 'react-router-dom';

const Backoffice = asyncComponent(() => import('../backoffice'));

const FTPMeusArquivos = asyncComponent(() =>
  import('../backoffice/FTP/MeusArquivos')
);
const FTPAutomacoes = asyncComponent(() =>
  import('../backoffice/FTP/Automacoes')
);
const FTPUsuarios = asyncComponent(() => import('../backoffice/FTP/Usuarios'));

const FilaDeAcionamento = asyncComponent(() =>
  import(
    '../backoffice/Operacional/ListarFilaDeAcionamento/ListaFilaDeAcionamento'
  )
);

const AcordosLiberados = asyncComponent(() =>
  import('../cobranca/diversos/AcodosLiberados/ListaAcordosLiberados')
);

const BaixaTitulosLote = asyncComponent(() =>
  import('../backoffice/Ferramentas/BaixaTitulosLote')
);

const MigracaoProcessos = asyncComponent(() =>
  import('../backoffice/Ferramentas/MigracaoProcessos')
);

const EncerrarProcessos = asyncComponent(() =>
  import('../backoffice/Ferramentas/EncerrarProcessos')
);

const Atualizacoes = asyncComponent(() => import('../diversos/Atualizacoes'));

const ModeloEmail = asyncComponent(() =>
  import('../backoffice/AcoesEletronicas/ModelosEmail')
);
const ModeloSMS = asyncComponent(() =>
  import('../backoffice/AcoesEletronicas/ModeloSMS')
);

const CampanhaEmail = asyncComponent(() =>
  import('../backoffice/AcoesEletronicas/CampanhaEmail')
);
const CampanhaBoleto = asyncComponent(() =>
  import('../backoffice/AcoesEletronicas/CampanhaBoleto')
);
const CampanhaSMS = asyncComponent(() =>
  import('../backoffice/AcoesEletronicas/CampanhaSMS')
);

const DiscadorMailling = asyncComponent(() => import('../backoffice/Discador'));
const DiscadorMaillingAuto = asyncComponent(() =>
  import('../backoffice/DiscadorAuto')
);

const ControlDesk = asyncComponent(() => import('../backoffice/ControlDesk'));

const DevolucaoTitulos = asyncComponent(() =>
  import('../backoffice/Devolucao/DevolucaoDeTitulos/ListaDevolucaoTitulos')
);

const DevolucaoPorPrazo = asyncComponent(() =>
  import('../backoffice/Devolucao/DevolucaoPrazo/ListaDevolucaoPrazo')
);

const TitulosSeremLiberados = asyncComponent(() =>
  import('../backoffice/Operacional/TitulosSeremLiberados')
);

const Negativacao = asyncComponent(() =>
  import('../backoffice/Operacional/Negativacao')
);

const DocumentosDigitais = asyncComponent(() =>
  import('../backoffice/Operacional/DocumentosDigitais')
);

const ListaSMSEnviados = asyncComponent(() =>
  import('../backoffice/ListaSMSEnviados/ListaSMSEnviados')
);
const ListaEmailsEnviados = asyncComponent(() =>
  import('../backoffice/ListaEmailsEnviados/ListaEmailsEnviados')
);

const HistoricoDeAcesso = asyncComponent(() =>
  import('../backoffice/HistoricoDeAcesso/ListarHistoricoDeAcesso')
);
const HistoricoDeAcoes = asyncComponent(() =>
  import('../backoffice/HistoricoDeAcoes/ListarHistoricoDeAcoes')
);

const HistoricoHigienizacao = asyncComponent(() =>
  import('../backoffice/HistoricoHigienizacao/ListaHistoricoHigienizacao')
);

const ImportacaoTitulos = asyncComponent(() =>
  import('../backoffice/importacoes/Titulos')
);
const HigienizacaoDevedores = asyncComponent(() =>
  import('../backoffice/HigienizacaoDevedor')
);
const HigienizacaoTitulos = asyncComponent(() =>
  import('../backoffice/HigienizacaoTitulos')
);
const ImportacaoTitulosBaixaCarteira = asyncComponent(() =>
  import('../backoffice/importacoes/TitulosBatimento')
);
const ImportacaoTitulosBaixas = asyncComponent(() =>
  import('../backoffice/importacoes/TitulosBaixa')
);
const ImportacaoFonesEmLote = asyncComponent(() =>
  import('../backoffice/importacoes/FonesEmLote')
);
const ManutencaoDeImportacoes = asyncComponent(() =>
  import('../backoffice/importacoes/manutencao')
);
const LotesCredor = asyncComponent(() =>
  import('../backoffice/importacoes/LotesCredor')
);
const ImportacaoOcorrencias = asyncComponent(() =>
  import('../backoffice/importacoes/Ocorrencias')
);

const DistruicaoDeProcessosPlanilha = asyncComponent(() =>
  import('../backoffice/importacoes/DistribuicaoProcessosPlanilhas')
);

const AtualizacaoTagsProcessosPlanilhas = asyncComponent(() =>
  import('../backoffice/importacoes/AtualizacaoTagsProcessoPlanilha')
);

const TrocaDeAcordoNegociador = asyncComponent(() =>
  import('../backoffice/importacoes/AcordosPorPlanilha')
);

const DevedorTitulosExcluidos = asyncComponent(() =>
  import('../backoffice/Ferramentas/DevedorTituloExcluido')
);

const AtualizaStatusProcessoEmLote = asyncComponent(() =>
  import('../backoffice/importacoes/AtualizarStatusProcessoPlanilha')
);

const Ferramentas0501 = asyncComponent(() =>
  import('../backoffice/Ferramentas/05/0501')
);
const Ferramentas0502 = asyncComponent(() =>
  import('../backoffice/Ferramentas/05/0502')
);

const ImportacaoRecebimentosGera = asyncComponent(() =>
  import('../backoffice/Ferramentas/188/ImportacaoRecebimentosGera')
);

const ImportacaoCRMs = asyncComponent(() =>
  import('../backoffice/Ferramentas/ImportacaoCRMs/ImportacaoCRMs')
);

const AutomacoesBackofficeRelatorios = asyncComponent(() =>
  import('../backoffice/Automacoes/Relatorios')
);
const AutomacoesBackofficeDiversos = asyncComponent(() =>
  import('../backoffice/Automacoes/Diversos')
);

const ListarEventosGeral = asyncComponent(() =>
  import('../backoffice/Automacoes/Eventos')
);

export default function BackofficeRoutes({ match }) {
  return (
    <>
      <Switch>
        <PrivateRoute
          path={`${match.url}/backof/updates`}
          component={Atualizacoes}
          codigo="back_controldesk"
        />
        <PrivateRoute
          path={`${match.url}/backof/controldesk`}
          component={ControlDesk}
          codigo="back_controldesk"
        />
        <PrivateRoute
          path={`${match.url}/backof/devolucao/devolucao-por-prazo`}
          component={DevolucaoPorPrazo}
          codigo="back_devolucao"
        />
        <PrivateRoute
          path={`${match.url}/backof/devolucao/devolucao-titulos`}
          component={DevolucaoTitulos}
          codigo="back_devolucao"
        />

        {/* FTP */}
        <PrivateRoute
          path={`${match.url}/backof/ftp/meus-arquivos`}
          component={FTPMeusArquivos}
          codigo="back.ftp"
        />
        <PrivateRoute
          path={`${match.url}/backof/ftp/automacoes`}
          component={FTPAutomacoes}
          codigo="back.ftp"
        />
        <PrivateRoute
          path={`${match.url}/backof/ftp/usuarios`}
          component={FTPUsuarios}
          codigo="back.ftp"
        />

        <PrivateRoute
          path={`${match.url}/backof/operacional/fila-acionamento`}
          component={FilaDeAcionamento}
          codigo="back_fila_acionamento"
        />
        <PrivateRoute
          path={`${match.url}/backof/operacional/acordos-liberados`}
          component={AcordosLiberados}
          codigo="back_liberacao_acordo"
        />
        <PrivateRoute
          path={`${match.url}/backof/operacional/titulos-serem-liberados`}
          component={TitulosSeremLiberados}
          codigo="back_titulos_a_liberar"
        />
        <PrivateRoute
          path={`${match.url}/backof/operacional/negativacao`}
          component={Negativacao}
          codigo="back_negativacao"
        />
        <PrivateRoute
          path={`${match.url}/backof/operacional/documentos-digitais`}
          component={DocumentosDigitais}
          codigo="back_documentos_digitais"
        />
        <PrivateRoute
          path={`${match.url}/backof/historico-de-acesso`}
          component={HistoricoDeAcesso}
          codigo="back_hist_acessos"
        />
        <PrivateRoute
          path={`${match.url}/backof/historico-de-acoes`}
          component={HistoricoDeAcoes}
          codigo="back_hist_acessos"
        />
        <PrivateRoute
          path={`${match.url}/backof/historico-higienizacao`}
          component={HistoricoHigienizacao}
          codigo="back_controldesk"
        />
        <PrivateRoute
          path={`${match.url}/backof/sms-enviados`}
          component={ListaSMSEnviados}
          codigo="back_controldesk"
        />
        <PrivateRoute
          path={`${match.url}/backof/emails-enviados`}
          component={ListaEmailsEnviados}
          codigo="back_controldesk"
        />
        <PrivateRoute
          path={`${match.url}/backof/higienizacao-devedores`}
          component={HigienizacaoDevedores}
          codigo="back_higienizacao_dev"
        />
        <PrivateRoute
          path={`${match.url}/backof/higienizacao-titulos`}
          component={HigienizacaoTitulos}
          codigo="back.higienizacao.tit"
        />
        <PrivateRoute
          path={`${match.url}/backof/tools/baixas-por-planilha`}
          component={ImportacaoTitulosBaixas}
          codigo="back_baixas_titulos_planilha"
        />
        <PrivateRoute
          path={`${match.url}/backof/importacoes/Titulos`}
          component={ImportacaoTitulos}
          codigo="back_importacoes_tit"
        />
        <PrivateRoute
          path={`${match.url}/backof/importacoes/titulos-baixa`}
          component={ImportacaoTitulosBaixaCarteira}
          codigo="back_importacoes_tit"
        />
        <PrivateRoute
          path={`${match.url}/backof/importacoes/titulos-manutencao`}
          component={ManutencaoDeImportacoes}
          codigo="back_manutencao_tit"
        />
        <PrivateRoute
          path={`${match.url}/backof/importacoes/lotes-credor`}
          component={LotesCredor}
          codigo="back_importacoes_tit"
        />
        <PrivateRoute
          path={`${match.url}/backof/importacoes/ocorrencias`}
          component={ImportacaoOcorrencias}
          codigo="back_importacao_oco"
        />
        <PrivateRoute
          path={`${match.url}/backof/tools/distribuicao-processos-planilha`}
          component={DistruicaoDeProcessosPlanilha}
          codigo="back_distribuicao_processo_planilha"
        />
        <PrivateRoute
          path={`${match.url}/backof/tools/atualizacao-tags-processos-planilha`}
          component={AtualizacaoTagsProcessosPlanilhas}
          codigo="tab_tags_marcacoes"
        />
        <PrivateRoute
          path={`${match.url}/backof/tools/troca-negociador-acordo`}
          component={TrocaDeAcordoNegociador}
          codigo="back_alterar_neg_acordo_planilha"
        />
        <PrivateRoute
          path={`${match.url}/backof/tools/atualiza-status-processo-em-lote`}
          component={AtualizaStatusProcessoEmLote}
          codigo="back_atualizar_status_planilha"
        />
        <PrivateRoute
          path={`${match.url}/backof/tools/devedores-titulos-excluidos`}
          component={DevedorTitulosExcluidos}
          codigo="back_devedor_titulo_excluido"
        />
        <PrivateRoute
          path={`${match.url}/backof/acoeseletronicas/modelo-email`}
          component={ModeloEmail}
          codigo="back_acoes_email"
        />
        <PrivateRoute
          path={`${match.url}/backof/acoeseletronicas/modelo-sms`}
          component={ModeloSMS}
          codigo="back_acoes_sms"
        />
        <PrivateRoute
          path={`${match.url}/backof/acoeseletronicas/campanha-email`}
          component={CampanhaEmail}
          codigo="back_acoes_email"
        />
        <PrivateRoute
          path={`${match.url}/backof/acoeseletronicas/campanha-sms`}
          component={CampanhaSMS}
          codigo="back_acoes_sms"
        />
        <PrivateRoute
          path={`${match.url}/backof/acoeseletronicas/campanha-boleto`}
          component={CampanhaBoleto}
          codigo="back_acoes_boletos"
        />
        <PrivateRoute
          path={`${match.url}/backof/discador/mailling`}
          component={DiscadorMailling}
          codigo="back_discador"
        />
        <PrivateRoute
          path={`${match.url}/backof/discador/mailling-auto`}
          component={DiscadorMaillingAuto}
          codigo="back_discador"
        />

        <PrivateRoute
          path={`${match.url}/backof/tools/0501`}
          component={Ferramentas0501}
          codigo="back_controldesk"
        />
        <PrivateRoute
          path={`${match.url}/backof/tools/0502`}
          component={Ferramentas0502}
          codigo="back_controldesk"
        />
        <PrivateRoute
          path={`${match.url}/backof/tools/importar-recebimentos-gera`}
          component={ImportacaoRecebimentosGera}
          codigo="back_controldesk"
        />

        <PrivateRoute
          path={`${match.url}/backof/tools/importacao-crms-diversos`}
          component={ImportacaoCRMs}
          codigo="back_importacoes_tit"
        />

        <PrivateRoute
          path={`${match.url}/backof/tools/baixa-titulos-lote`}
          component={BaixaTitulosLote}
          codigo="back_baixas_titulos_lote"
        />

        <PrivateRoute
          path={`${match.url}/backof/tools/migrar-processos`}
          component={MigracaoProcessos}
          codigo="back_migrar_processos"
        />

        <PrivateRoute
          path={`${match.url}/backof/tools/encerrar-processos`}
          component={EncerrarProcessos}
          codigo="back_encerrar_processo_sem_saldo"
        />

        <PrivateRoute
          component={AutomacoesBackofficeRelatorios}
          path={`${match.url}/backof/automacoes/relatorios`}
          codigo="back_automacoes"
        />

        <PrivateRoute
          component={AutomacoesBackofficeDiversos}
          path={`${match.url}/backof/automacoes/diversos`}
          codigo="back_automacoes"
        />

        <PrivateRoute
          path={`${match.url}/backof/automacoes/eventos`}
          component={ListarEventosGeral}
          codigo="back_automacoes"
        />

        <PrivateRoute
          path={`${match.url}/backof/tools/atualizacao-telefones-planilha`}
          component={ImportacaoFonesEmLote}
          codigo="back_atualiza_fones"
        />

        <PrivateRoute
          path={`${match.url}/backof/inicio`}
          component={Backoffice}
          codigo="modulo_backoffice"
        />
        <PrivateRoute
          exact
          path={`${match.url}/backof`}
          component={Backoffice}
          codigo="modulo_backoffice"
        />
      </Switch>
    </>
  );
}
